import { useFormContext } from "react-hook-form";
import { useTranslation } from "next-i18next";

import { Stack } from "common/ui/Stack";
import { Input } from "common/ui/Input";
import { PhoneInput } from "common/ui/PhoneInput";
import { AddressInputs } from "common/elements/AddressInputs";
import { type AddressInputsValues } from "common/elements/AddressInputs";

import { formatDateToYYYYMMDD } from "common/utils/utils";

export interface BrokerFormValues {
  brokerLicenseNum: string,
  brokerLicenseJurisdiction: string,
  brokerLicenseExpiryDate: string,
  brokerageName: string,
  brokerageTaxNum: string,
  brokerageAddress: AddressInputsValues,
  brokeragePhone: string,
}

interface Props {
  isEditing?: boolean,
}

export const BrokerFormInputs = ({ isEditing }: Props) => {
  const { t } = useTranslation("common");
  const {
    register,
    formState: { errors },
  } = useFormContext<BrokerFormValues>();

  return (
    <Stack direction="column" gap={16}>
      <Input
        label={t("brokerFormInputs.licenseNum")}
        errors={errors}
        {...register("brokerLicenseNum")}
        readOnly={isEditing}
      />
      <Input
        label={t("brokerFormInputs.licenseJurisdiction")}
        errors={errors}
        {...register("brokerLicenseJurisdiction")}
        readOnly={isEditing}
      />
      <Input
        label={t("brokerFormInputs.expiryDate")}
        type="date"
        errors={errors}
        {...register("brokerLicenseExpiryDate")}
        readOnly={isEditing}
        min={formatDateToYYYYMMDD(new Date())}
      />
      <Input
        label={t("brokerFormInputs.brokerageName")}
        errors={errors}
        {...register("brokerageName")}
      />
      <Input
        label={t("brokerFormInputs.brokerageTaxNum")}
        errors={errors}
        {...register("brokerageTaxNum")}
      />
      <AddressInputs
        label={t("brokerFormInputs.brokerageAddress")}
        fieldPrefix="brokerageAddress"
      />
      <PhoneInput
        label={t("brokerFormInputs.brokeragePhone")}
        name="brokeragePhone"
      />
    </Stack>
  )
}
